export default __webpack_public_path__ + "img/26.f8dd57.png";